import {Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'feedbackCount-dialog',
    templateUrl: 'feedbackCount.dialog.html',
})
export class FeedbackCountDialog {

    constructor(@Inject(MAT_DIALOG_DATA) public data: {
        correctAnswersCount: number,
        totalAnswersCount: number,
        type: string,
        percentage: string,
        demo: boolean
    },
    public translate: TranslateService){

    }
}
